import React from 'react';
import '../styles/UpgradeModal.css';

const UpgradeModal = ({ onClose, onUpgrade }) => {
    const features = [
        {
            category: 'Course Generation',
            free: '--',
            premium: '5 courses/month'
        },
        {
            category: 'Course Settings Control',
            free: '--',
            premium: 'Set vocabulary level and course length',
            highlight: false
        },
        {
            category: 'Quiz & Progress Tracking',
            free: 'Available',
            premium: 'Available'
        },
        {
            category: 'Chapter Projects',
            free: 'Available for skill-based courses',
            premium: 'Available for skill-based courses'
        }
    ];

    return (
        <div className="upgrade-modal-overlay" onClick={onClose}>
            <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close-btn" onClick={onClose} aria-label="Close">
                    ×
                </button>

                <div className="upgrade-header">
                    <h2>Unlock Premium Features</h2>
                    <p className="upgrade-subtitle">
                        Get more control over your learning experience with Premium
                    </p>
                </div>

                <div className="comparison-table">
                    <div className="table-header">
                        <div className="header-cell feature-col">Feature</div>
                        <div className="header-cell free-col">Free</div>
                        <div className="header-cell premium-col">Premium</div>
                    </div>

                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className={`table-row ${feature.highlight ? 'highlight-row' : ''}`}
                        >
                            <div className="table-cell feature-name">
                                {feature.category}
                                {feature.highlight && (
                                    <span className="new-badge">You need this</span>
                                )}
                            </div>
                            <div className="table-cell free-value">
                                {feature.free}
                            </div>
                            <div className="table-cell premium-value">
                                {feature.premium}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="upgrade-footer">
                    <div className="price-info">
                        <div className="price">$8.99<span className="period">/month</span></div>
                        <p className="price-note">Cancel anytime. No long-term commitments.</p>
                    </div>
                    <button
                        className="upgrade-btn"
                        onClick={onUpgrade}
                    >
                        Upgrade to Premium
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeModal;
